import { Spin } from "antd";
import { RevebueAcrossCountries } from "pages/internal-dashboard/icons";
import { UseApiCallForOldDashboardData } from "hooks/use-api-call-for-old-dashboard";
import { getCountriesRevnueData } from "./helpers";
import styles from "./styles.module.scss";

export const CountriesRevenue = ({ height }) => {
  const { data: countriesRevenue, isLoading: countrieshRevenueLoading } =
    UseApiCallForOldDashboardData({
      url: "revenue_by_countries",
      method: "POST",
      body: {
        data: "none",
      },
    });

  let data = getCountriesRevnueData(countriesRevenue);

  const funnelChartHeight = parseInt(height - 55);
  const funnelChartWidth = parseInt(funnelChartHeight * 1.1);

  const borderTop = funnelChartHeight / 5;
  const eachLevelHeight = funnelChartHeight / 5 - 1;
  const borderLeftRight = funnelChartWidth / 10;

  // console.table({
  //   funnelChartHeight,
  //   funnelChartWidth,
  //   borderTop,
  //   borderLeftRight,
  // });

  return (
    <Spin spinning={countrieshRevenueLoading}>
      <div className={styles["chart-container"]}>
        <div className={styles["header"]}>
          <span>
            <RevebueAcrossCountries />
          </span>
          Revenue Across Countries
        </div>
        <div className={styles["chart-data"]}>
          <div
            className={styles["funnel-chart"]}
            style={{
              width: funnelChartWidth + "px",
              height: funnelChartHeight + "px",
              "--border-top": borderTop + "px",
              "--border-width": borderLeftRight + "px",
            }}
          >
            {data.map((entry, index) => (
              <div
                key={index}
                className={styles["funnel-level"]}
                style={{
                  width: `${entry.value}%`,
                  height: eachLevelHeight + "px",
                  // backgroundColor: `rgba(0, 123, 255, ${1 - index * 0.2})`,
                  "--color1": entry?.color1,
                  "--color2": entry?.color2,
                }}
              >
                <span className={styles["triangleRight"]}></span>
                <span className={styles["funnel-label"]}>{entry.name}</span>
                <span className={styles["triangleLeft"]}></span>
              </div>
            ))}
          </div>
          <div className={styles["chart-labels"]}>
            {data.map((state) => {
              return (
                <div className={styles["label"]}>
                  <span
                    style={{
                      "--color1": state?.color1,
                      "--color2": state?.color2,
                    }}
                  ></span>
                  {state?.country}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Spin>
  );
};
